export const DEFAULT_CURRENCY = 'GBP';
